import * as React from 'react';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';

export interface LineBreakProps {
  /**
   * Text to split by ``linebreakChar`
   */
  text: string;
  /**
   * Defaults to newline char `\n`
   */
  lineBreakChar?: string;
}

export const BreakLines = (props: LineBreakProps) => {
  const lines = !!props.text &&
   insertOptionalWordbreaks(props.text).split( props.lineBreakChar || '\\n' );

  return <>
    {lines && lines.map((item, key) =>
      <React.Fragment key={key}>
        {item}{lines.length - 1 === key ? null : <br />}
      </React.Fragment>)}
  </>;
};
